import { createContext, useContext } from 'react'

import { noop } from '../../utils/noop'

export type ErrorNotificationContextType = {
  showError: () => void
  hideError: () => void
  registerOutlet: (outlet: HTMLElement | null) => () => void
}

export const ErrorNotificationContext = createContext<ErrorNotificationContextType>({
  showError: noop,
  hideError: noop,
  registerOutlet: () => noop,
})

export const useErrorNotification = () => useContext(ErrorNotificationContext)
